import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';
import { BankOperationValue } from 'constants/bankOperationTypes';

import { Currency } from './currency';
import { Direction } from './direction';
import { Merchant } from './merchant';
import { MerchantAccount } from './merchantAccount';
import { Provider } from './provider';
import { Referral } from './referral';
import { User } from './user';

export type BankOperationStatus = {
  value: BankOperationStatusesNew;
  description: string;
  id: string;
  '@id': string;
};

export type BankOperationComment = {
  id: number;
  '@id': string;
  text: string;
  createdAt: string;
  bankOperation: string;
  commentText: string;
  createdAtTimestamp: number;
  status: Partial<BankOperationStatus>;
  user: Partial<User>;
};

export type BankOperationType = {
  value: BankOperationValue;
  description: string;
  id: string;
  '@id': string;
};

export type BankOperation = {
  id: string;
  '@id': string;
  amountPenny: string;
  currency: Partial<Currency>;
  gateway: string;
  provider: Partial<Provider>;
  merchant: Partial<Merchant>;
  merchantAccount: Partial<MerchantAccount>;
  originId: number;
  comment: string;
  dateOfOperation: number | Date;
  status: BankOperationStatus;
  comments: BankOperationComment[];
  description?: string;
  type: BankOperationType;
  related?: BankOperation;
  direction: Direction;
  referral: Partial<Referral>;
  commentCount: number;
  user: Partial<User>;
};

export const enum ImportFileStatuses {
  Created = 'created',
  Validating = 'validating', // Проверка файла в процессе
  WaitingDecision = 'waiting_decision', // В процессе проверки ошибки
  Saving = 'saving',
  Saved = 'saved',
  Rejected = 'rejected',
  Fail = 'fail',
}

export type ImportFileStatusesValue = (typeof ImportFileStatuses)[keyof typeof ImportFileStatuses];

export type ImportFileStatus = {
  '@id': string;
  id: string;
  description: string;
  name: string;
  value: ImportFileStatusesValue;
};

export type ImportFile = {
  '@id': string;
  id: string;
  emptyRows: number;
  errorRows: number;
  filePath: string;
  processedRows: number;
  status: string;
  totalRows: number;
  user: string;
  validRows: number;
};

export type ImportRow = {
  '@id': string;
  id: string;
  errorMessages: Record<string, Record<string, string>>;
  numberRow: number;
  status: string;
  type: string;
};
